// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1W6Ix","upload":"Small_upload__3lkxg","imageWrap":"Small_imageWrap__3KKZc","removeBtn":"Small_removeBtn__32Ccp"};